// extracted by mini-css-extract-plugin
module.exports = {"image":"CardIssuer_image__38san"};